var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"world-icon"})}
var staticRenderFns = []

export { render, staticRenderFns }